// extracted by mini-css-extract-plugin
module.exports = {"base_panel":"BasePanel_base_panel__3XA2p","table_filter_panel":"BasePanel_table_filter_panel__2WfFa"};